// const setFixedOffset = (() => {
// 	function init() {
// 		window.addEventListener('DOMContentLoaded', () => {
// 			setHeight();
// 		});
// 	}

// 	function setHeight() {
// 		const header = document.querySelector('.site-header');
// 		if (header) {
// 			document.documentElement.style.setProperty('--offset', `${header.offsetHeight}px`);
// 		}
// 	}

// 	return {
// 		init,
// 	};
// })();

function setFixedOffset() {
  const header = document.querySelector(".site-header");
  if (header) {
    document.documentElement.style.setProperty(
      "--offset",
      `${header.offsetHeight}px`
    );
  }
}

export default setFixedOffset;
